import i18n from 'app/services/i18n';
import { Alert, AlertLevel, AlertsDispatch } from 'app/state/AlertsContext/Provider';
import { getErrorMessages } from 'app/utils/lib/api/getErrorMessages';

interface ErrorWithTitle {
  title?: string;
}

function generateAlerts({
  errorObject,
  expectedKeys,
  itemId,
  title = errorObject?.title ?? i18n.t('common:error', 'Error'),
}: {
  errorObject: ErrorWithTitle & object | undefined;
  expectedKeys: string[];
  itemId?: null | string;
  title?: string;
}): Alert[] {
  const errorMessageStrings = getErrorMessages({
    error: errorObject ?? {},
    expectedKeys,
  });

  return errorMessageStrings.map(message => ({
    actions: [],
    alertLevel: 'error',
    alertType: 'notification',
    itemId,
    message,
    timestamp: new Date().getTime(),
    title,
  }));
}

export function handleErrors({
  dispatch,
  errorObject,
  expectedKeys = [],
  itemId,
  title,
}: {
  dispatch: AlertsDispatch;
  errorObject: ErrorWithTitle & object;
  expectedKeys?: string[];
  itemId?: null | string;
  /**
   * Title for the notification
   * @default 'Error'
   */
  title?: string;
}) {
  const alerts = generateAlerts({
    errorObject,
    expectedKeys,
    itemId,
    title,
  });

  alerts.forEach(alert => {
    dispatch({
      payload: { alert },
      type: 'addAlert',
    });
  });
}

export function handleSuccess({
  alertLevel = 'success',
  dispatch,
  itemId,
  successMessage,
  title = i18n.t('common:success', 'Success'),
}: {
  alertLevel?: AlertLevel;
  dispatch: AlertsDispatch;
  itemId?: string;
  successMessage?: string;
  /**
   * Title for the notification
   * @default 'Success'
   */
  title?: string;
}) {
  dispatch({
    payload: {
      alert: {
        actions: [],
        alertLevel,
        alertType: 'notification',
        itemId,
        message: successMessage,
        timestamp: new Date().getTime(),
        title,
      },
    },
    type: 'addAlert',
  });
}
